import Vue from 'vue';
import Vuex from 'vuex';
import {EventBus} from '@/lib/event-bus';
import {AXIOS} from '@/lib/http-common';
import router from '@/lib/router';
import {EVENTBUS_TOPICS} from './constants';
import UserActionResultSender from "@/components/application/UserActionResultSender";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: localStorage.getItem('authUser'),
    // The error stores the i18n variable that is defined in the language files
    error: null,
    loading: false,
    auth: null,
    stompClient: {
      // Mock the connected state
      connected: false
    },
    cubiScanState: null,
    activeErrors: [],
    notificationQueue: [],
    productionProfileActive: false,
    demoProfileActive: false,
  },
  mutations: {
    setUser(state, payload) {
      // We cannot put JS Objects in localstorage, so store is as JSON string
      state.user = JSON.stringify(payload);
      localStorage.setItem('authUser', state.user);
    },
    clearAuth(state) {
      localStorage.removeItem('authUser');
      state.user = null;
      // Expire session cookies
      const cookies: string[] = document.cookie.split(';');

      cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      });
    },
    setError(state, payload) {
      // The error stores the i18n variable that is defined in the language files
      if (payload) {
        UserActionResultSender.showErrorFeedback(payload);
        state.error = payload;
      }
    },
    setLoading(state, payload) {
      state.loading = payload;
    }
  },
  actions: {
    submitCredentials({commit}, payload) {
      const crypto = require('crypto');
      const data = {
        password: crypto.createHash('md5').update(payload.password).digest("hex"),
        username: payload.username
      };
      commit('setLoading', true);
      commit('setError', null);
      AXIOS.post('/login', data)
        .then((res) => {
          // The login was successfull. Grab the JWT token from the cookie en decode it.
          const value = (new RegExp('COOKIE-BEARER' + '=([^;]+)')).exec(document.cookie);
          const jwtToken = (value != null) ? unescape(value[1]) : null;

          if (jwtToken !== null) {
            const authUser = JSON.parse(atob(jwtToken.split('.')[1]));
            // The user authorities are defined as CSV, let's convert them to an array
            authUser.authorities = authUser.authorities.split(',');
            commit('setUser', authUser);
            commit('setLoading', false);

            EventBus.$emit(EVENTBUS_TOPICS.AUTHENTICATED, 'User authenticated');
            router.push('/');
          }
        })
        .catch((error) => {
          commit('setError', "auth.error.invalidCredentials");
          commit('setLoading', false);
        });
    },
    userSignOut({ commit }, payload) {
      commit('clearAuth');
      if (payload) {
        commit('setError', payload.error);
      }
      EventBus.$emit(EVENTBUS_TOPICS.AUTHENTICATED, 'User not authenticated');
    }
  },
  getters: {
    /**
     * Get user object. Null of no user logged in, else it returns a User
     * (user.sub = username, user.authorities = array of auth levels, eg USER, ADMIN)
     *
     * @param {*} state
     */
    getUser(state) {
      // Our user data is stored as a JSON string, parse it as an objec
      return state.user ? JSON.parse(state.user) : null;
    },
    /**
     * Get CubiScan state object
     *
     * @param state
     */
    getCubiScanState(state) {
      return state.cubiScanState;
    }
  },
});

export default store;
